import { Navigate } from 'react-router-dom';
import Loadable from 'app/components/Loadable';
import { lazy } from 'react';
import useAuth from 'app/hooks/useAuth';


const Blank = Loadable(lazy(() => import('./pages/Blank')));

const Dasboard = Loadable(lazy(() => import('./pages/Analytics')));
const UserDashboard = Loadable(lazy(() => import('./pages/UserDashboard/UserDashboard')))
const Followups = Loadable(lazy(() => import('./pages/Followups/TodaysFollowupsAndBacklogs')));

// Contact
const Contact = Loadable(lazy(() => import('./pages/Contact/ContactTable')));
const ContactForm = Loadable(lazy(() => import('./pages/Contact/ContactForm')));

// Property
const Property = Loadable(lazy(() => import('./pages/Property/PropertyTable')));
const PropertyForm = Loadable(lazy(() => import('./pages/Property/PropertyForm')));

// Property
const PropertyAttachment = Loadable(lazy(() => import('./pages/Property/Media/PropertyAttachment')));
// const PropertyAttachmentForm = Loadable(lazy(() => import('./pages/Property/PropertyForm')));

// Leads
const Leads = Loadable(lazy(() => import('./pages/Leads/LeadsTable')));
const LeadsForm = Loadable(lazy(() => import('./pages/Leads/LeadsForm')));

// Opportunities
const OpportunityTable = Loadable(lazy(() => import('./pages/Opportunity/OpportunityTable')));
const OpportunityForm = Loadable(lazy(() => import('./pages/Opportunity/OpportunityForm')));

// Call Attempts
const LeadActionsTable = Loadable(lazy(() => import('./pages/LeadActions/LeadActionsTable')));

// Suggestions
const PropertySuggestions = Loadable(lazy(() => import('./pages/Opportunity/PropertySuggestionsTable')));
const LeadSuggestions = Loadable(lazy(() => import('./pages/Property/LeadSuggestionsTable')));


// PROJECTS
const ProjectsTable = Loadable(lazy(() => import('./pages/Project/ProjectTable')))
const ProjectLeadSuggestions = Loadable(lazy(() => import('./pages/Project/ProjectLeadSuggestionsTable')))
const ProjectForm = Loadable(lazy(() => import('./pages/Project/ProjectForm')))

// PROJECT CONFIGS
const ProjectConfigsTable = Loadable(lazy(() => import('./pages/Project/Configs/ProjectConfigsTable')))
const ProjectConfigForm = Loadable(lazy(() => import('./pages/Project/Configs/ProjectConfigForm')))

// PROJECTS MEDIA
const ProjectAttachment = Loadable(lazy(() => import('./pages/Project/Media/ProjectAttachment')));


// Utils
const Cities = Loadable(lazy(() => import('./pages/Util/CitiesTable')));
const Amenities = Loadable(lazy(() => import('./pages/Util/AmenitiesTable')));
const Logs = Loadable(lazy(() => import('./pages/Util/LogsTable')));
const NotificationTester = Loadable(lazy(() => import('./pages/Util/NotificationTester')));
const Notifications = Loadable(lazy(() => import('./pages/NotificationsPage')));

// Users & Lead Routing
const UsersTable = Loadable(lazy(() => import('./pages/Users/UsersTable')));
const LeadRoutingTable = Loadable(lazy(() => import('./pages/Users/LeadRoutingTable')));

const DashboardWrapper = () => {
  const roleId = localStorage.getItem('roleId');
  return roleId === '1' ? <UserDashboard /> : <Dasboard />;
};

const MasterLogout = () => {
  const { logout } = useAuth();
  logout();
  return <Navigate to="/" />;
};

const masterRoutes = [
  {
    path: '/master/blank',
    element: <Blank />,
  },
  {
    path: '/dashboard',
    element: <DashboardWrapper />,
  },
  {
    path: '/user-dashboard',
    element: <UserDashboard />,
  },
  // Contact
  {
    path: '/contact',
    element: <Contact />,
  },
  {
    path: '/contact-form',
    element: < ContactForm />,
  },
  // Property
  {
    path: '/property',
    element: <Property />,
  },
  {
    path: '/property-form',
    element: <PropertyForm />,
  },
  // Property Attachments
  {
    path: '/property-attachments',
    element: <PropertyAttachment />,
  },

  // Leads
  {
    path: '/lead',
    element: <Leads />,
  },
  {
    path: '/leads-form',
    element: <LeadsForm />,
  },
  //Oppurtunities
  {
    path: '/opportunity-form',
    element: <OpportunityForm />,
  },
  {
    path: '/opportunities',
    element: <OpportunityTable />,
  },
  // Call Attempt
  {
    path: '/lead-actions',
    element: <LeadActionsTable />,
  },
  // Suggestions
  {
    path: '/property-suggestions',
    element: <PropertySuggestions />,
  },
  {
    path: '/lead-suggestions',
    element: <LeadSuggestions />,
  },
  {
    path: '/project-lead-suggestions',
    element: <ProjectLeadSuggestions />,
  },
  // Utils
  {
    path: '/cities',
    element: <Cities />,
  },
  {
    path: '/amenities',
    element: <Amenities />,
  },
  {
    path: '/logs',
    element: <Logs />,
  },
  {
    path: '/notification-test',
    element: <NotificationTester />,
  },
  {
    path: '/users',
    element: <UsersTable />,
  },
  {
    path: '/lead-routing',
    element: <LeadRoutingTable />,
  },
  {
    path: '/notifications',
    element: <Notifications />,
  },
  {
    path: '/followups',
    element: <Followups />,
  },

  // PROJECTS
  {
    path: '/projects',
    element: < ProjectsTable />
  },
  {
    path: '/project-form',
    element: <ProjectForm />
  },

  // PROJECT CONFIGS
  {
    path: '/project-configs',
    element: < ProjectConfigsTable />
  },
  {
    path: '/project-config-form',
    element: <ProjectConfigForm />
  },

  // PROJECT MEDIA
  {
    path: '/project-attachments',
    element: <ProjectAttachment />
  },

  // Logout
  {
    path: '/master/logout',
    element: <MasterLogout />,
  },
];

export default masterRoutes;
